export default "__VITE_ASSET__c1d1f800__"